import React, { useState } from "react";
import { Box, Button, Typography, Grid } from "@mui/material";

const HomeSlider = ({ setOpenLogin, setToggleForm }) => {
  const [index, setIndex] = useState(0);

  return (
    <>
      <Box sx={{ maxWidth: "1440px", mx: "auto", px: 4, pt: 5, pb: 6 }}>
        {/* Mobile-only image above content */}
        <Box
          component="img"
          src="/homeimg2.png"
          alt="AR Mobile Top"
          sx={{
            display: { xs: "block", md: "none" },
            width: "90%",
            borderRadius: 2,
            mx: "auto",
            mb: 3,
          }}
        />
        {/* Wrapper to ensure same height for both columns on md+ */}
        <Box
          sx={{
            display: { xs: "block", md: "flex" },
            minHeight: { md: "500px" },
            alignItems: "center",
          }}
        >
          {/* Left Content */}
          <Box
            sx={{
              width: { xs: "100%", md: "40%" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              pr: { md: 4 },
              ml:{md:5}
            }}
          >   
            <Typography
              fontWeight="bold"
              sx={{
                textAlign: "left",
                lineHeight: 1.2,
                fontSize: { xs: "28px", sm: "32px", md: "38.4px", lg: "42px" },
                color: "black",
              }}
            >
              Step into a new age of product{" "}
              <Box
                component="span"
                sx={{ color: "orangered", display: "inline" }}
              >
                visualisation
              </Box>{" "}
              with{" "}
              <Box
                component="span"
                sx={{ color: "orangered", display: "inline" }}
              >
                ArNXT
              </Box>
            </Typography>
            <Typography
              variant="body1"
              mt={3}
              mb={4}
              sx={{
                color: "#000",
                fontSize: "1rem",
                textAlign: "left",
              }}
            >
              ArNXT is poised to transform our shopping experience, blending
              convenience, instant access, immersive and personal touch into one
              seamless mix.
            </Typography>
            <Box sx={{ textAlign: { xs: "left", md: "left" } }}>
              <Button
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: "#012A38",
                  color: "#fff",
                  fontWeight: "bold",
                  textTransform: "none",
                  px: 4,
                  py: 1.5,
                  fontSize: "16px",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#0a313fff",
                    transform: "scale(1.05)",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
                  },
                  transition: "all 0.3s ease",
                }}
                onClick={() => {
                  setOpenLogin(true);
                  setToggleForm("signup");
                }}
              >
                Get Started
              </Button>
            </Box>
          </Box>
          {/* Right images */}
          <Box
            sx={{
              width: { xs: "100%", md: "60%" },
              position: "relative",
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <Box
                component="img"
                src="/homeimg3.png"
                alt="AR 1"
                sx={{
                  width: "400px",
                  height: "220px",
                  borderRadius: 5,
                }}
              />
              <Box
                component="img"
                src="/homeimg2.png"
                alt="AR 3"
                sx={{
                  width: "400px",
                  height: "220px",
                  borderRadius: 5,
                }}
              />
            </Box>
            <Box
              component="img"
              src="/homeimg1.png"
              alt="AR Center"
              sx={{
                position: "absolute",
                left: "56%",
                transform: "translate(-20%, -50%)",
                top: "50%",
                width: "400px",
                height: "250px",
                borderRadius: 5,
                boxShadow: 10,
                zIndex: 2,
              }}
            />
          </Box>
              </Box>
          </Box>
         
    </>
  );
};

export default HomeSlider;
